module.exports = __webpack_public_path__ + "img/collection-en.d55e5364.png";